<script setup>
import { computed } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { usePointsStore } from '@/stores/points'

const translaterStore   = useTranslaterStore()
const pointsStore       = usePointsStore()

const getTranslate  = computed(() => translaterStore.getTranslate)
const carState      = computed(() => pointsStore.carState)

</script>

<template>
    <div 
        class="uta-car-online" 
        :class="{
            'uta-car-online--offline'      : !carState.online.value,
            'uta-car-online--nosatellites' : carState.online.value == 1,
            'uta-car-online--online'       : carState.online.value == 2,
        }" 
    >
        <!-- <span class="material-icons uta-car-online__icon">
            <template v-if="!carState.online.value">wifi_tethering_off</template>
            <template v-else-if="carState.online.value == 1">wifi_tethering</template>
            <template v-else-if="carState.online.value == 2">wifi_tethering</template>
        </span> -->
        {{ getTranslate[carState.online?.value_text] || getTranslate.OFFLINE }}
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/online.scss';
</style>